import { Field, Type } from 'serialize-ts';

import { BaseHttpError } from './base-http-error.model';
import { InvalidParams } from './invalid-params.model';
import { InvalidParamsSerializer } from '../classes/invalid-params-serializer.class';

export class BadRequestHttpError extends BaseHttpError {
  @Field()
  @Type(new InvalidParamsSerializer())
  invalidParams: InvalidParams = {};
}
